export default function isExtensionPath(path: string) {
  return path.startsWith('/extension-ui');
}
